module.exports = __webpack_public_path__ + "img/calendar.13586fa2.svg";